import apiClient from './api';

export interface MetarConfiguration {
  id: number;
  appelsParHeureHiver: number;
  appelsParHeureEte: number;
  moisHiver: number[];
  updatedAt: string;
  updatedBy?: { id: number; nom: string; prenom: string; nomComplet: string } | null;
}

export interface UpdateMetarConfigurationDTO {
  appelsParHeureHiver?: number;
  appelsParHeureEte?: number;
  moisHiver?: number[];
}

export interface MetarCompteurJour {
  jour: string;
  total: number;
  reussis: number;
  echecs: number;
}

export interface MetarCompteur {
  periode: { debut: string; fin: string };
  totaux: { total: number; reussis: number; echecs: number };
  parJour: MetarCompteurJour[];
}

export const MOIS_LABELS: Record<number, string> = {
  1: 'Janvier',
  2: 'Février',
  3: 'Mars',
  4: 'Avril',
  5: 'Mai',
  6: 'Juin',
  7: 'Juillet',
  8: 'Août',
  9: 'Septembre',
  10: 'Octobre',
  11: 'Novembre',
  12: 'Décembre',
};

export const metarConfigService = {
  async getConfiguration(): Promise<MetarConfiguration> {
    const response = await apiClient.get<MetarConfiguration>('/metar/configuration');
    return response.data;
  },

  async updateConfiguration(data: UpdateMetarConfigurationDTO): Promise<MetarConfiguration> {
    const response = await apiClient.put<MetarConfiguration>('/metar/configuration', data);
    return response.data;
  },

  async getCompteur(periode: 'jour' | 'mois' = 'jour', dateDebut?: string, dateFin?: string): Promise<MetarCompteur> {
    const params = new URLSearchParams();
    params.append('periode', periode);
    if (dateDebut) params.append('dateDebut', dateDebut);
    if (dateFin) params.append('dateFin', dateFin);

    const response = await apiClient.get<MetarCompteur>(`/metar/compteur?${params.toString()}`);
    return response.data;
  },
};

export default metarConfigService;
